import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const wetBulb_BELOW: typeof valueTypeRenderers.wetBulb_BELOW = {
  label: () => unitConverter.wetBulbBelowCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.wetBulbBelowCanopy().title(),
      render: (n) => unitConverter.wetBulbBelowCanopy(n).valueAsString(),
    }),
}
